'use client'
import { FC } from 'react'
import cx from 'classnames'
import { Colour } from '@/components/constants/colours'
import { Panel, PanelLayout } from '@/components/Panel/Panel'
import { PanelItem } from '@/components/Panel/PanelItem'
import styles from './styles.module.scss'
import { useIsDarkBackground } from '@/hooks/useBackgroundColourUtils'
import { SectionPaddingDefault } from '@/components/constants'
import { RichTextContent, useRichText } from '@/hooks/useRichText'
import { CmsPageSectionBase } from '@/components/ComposedPage/types'
export interface CmsDisclaimerSection extends CmsPageSectionBase {
  fields: CmsPageSectionBase['fields'] & {
    internalTitle?: string
    backgroundColour: Colour
    copy?: string
    copyRichText?: RichTextContent
  }
}

export const DisclaimerSection: FC<CmsDisclaimerSection> = ({ fields }) => {
  const {
    backgroundColour,
    sectionPaddingTop = SectionPaddingDefault.TOP,
    sectionPaddingBottom = SectionPaddingDefault.BOTTOM,
    copy,
    copyRichText,
  } = fields

  const isDark = useIsDarkBackground(Colour[backgroundColour])

  return (
    <Panel layout={PanelLayout.full} colour={Colour[backgroundColour]} short>
      <PanelItem
        className={cx(
          styles.disclaimerSection,
          styles[sectionPaddingTop || SectionPaddingDefault.TOP],
          styles[sectionPaddingBottom || SectionPaddingDefault.BOTTOM],
          { [styles.isDarkBackground]: isDark },
        )}
      >
        {copy && <span className={styles.copy}>{copy}</span>}
        {copyRichText && (
          // oxlint-disable-next-line react-hooks/rules-of-hooks
          <span className={styles.copy}>{useRichText(copyRichText)}</span>
        )}
      </PanelItem>
    </Panel>
  )
}

export default DisclaimerSection
